import 'es6-object-assign/auto'
import Vue from 'vue'
import EventRegistrationPage from './EventRegistrationPage.vue'
import '../../common/GlobalVueConfig';

new Vue({
    render: h => h(EventRegistrationPage)
}).$mount('#event-registration-app');
